import { render, staticRenderFns } from "./SuppliersRawMaterialList.vue?vue&type=template&id=66b836ec&scoped=true&"
import script from "./SuppliersRawMaterialList.vue?vue&type=script&lang=js&"
export * from "./SuppliersRawMaterialList.vue?vue&type=script&lang=js&"
import style0 from "./SuppliersRawMaterialList.vue?vue&type=style&index=0&id=66b836ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b836ec",
  null
  
)

export default component.exports